import React, { useEffect, useState } from "react";
import LayoutWrapper from "../layout/layoutWrapper/LayoutWrapper";
import Faqs from "../widgets/faqs/Faqs";
import ProductListingBrand from "../widgets/productListing/ProductListingBrand";
import TipOfTheDay from "../widgets/tipOfTheDay/TipOfTheDay";
import { Helmet } from "react-helmet";
import "./productcategorybrand.css"

const Loader = () => <div className="spinner"></div>;

const ProductWithBrand = () => {
  const [brandList, setBrandList] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(true);

  const tipOfTheDay = {
    title:
      "<span class='text-red'>Tip</span> of the <span class='text-skyblue'>Day</span>",
    description:
      "Page yield is how many pages your printer cartridge can produce before it needs replacement. To calculate the Paper cost, here's another math task:",
  };

  useEffect(() => {
    setLoadingBrands(true);
    fetch("https://backend.inkox.com/api/brand")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && Array.isArray(data[0])) {
          setBrandList(data[0]);
        } else {
          setBrandList([]);
        }
        setLoadingBrands(false);
      })
      .catch((err) => {
        console.error("Error fetching brand list:", err);
        setLoadingBrands(false);
      });
  }, []);

  const brandDataForListing = brandList.map((brand) => ({
    image: `https://backend.inkox.com/storage/SNS_Canada_Images_Webp/Brand_Webp/${brand.replace(/\s+/g, "-")}.webp`,
    title: brand,
    link: `${brand.replace(/\s+/g, "-")}`,
  }));

  return (
    <>
      <Helmet>
        <title>All Brands - Inkox</title>
        <meta name="description" content="Browse all available brands on Inkox." />
      </Helmet>
      <div className="brand-page">

      <LayoutWrapper>
        {loadingBrands ? (
          <Loader />
        ) : (
          <>

            <ProductListingBrand
              data={brandDataForListing}
              selectedCategoryName="All Brands"
            />
            <Faqs />
            <TipOfTheDay bgColor="#fff" data={tipOfTheDay} />
          </>
        )}
      </LayoutWrapper>
      </div>
    </>
  );
};

export default ProductWithBrand;
